<div class="ng-content" mat-dialog-title>
  @if (caption()) {
    <span class="header-title">{{ caption() }}</span>
  }

  @if (shouldShowCloseButton()) {
    <button matIconButton mboIconButton [mboSize]="iconSize()" (click)="closeDialog.emit()">
      <mat-icon mboIcon [mboSize]="iconSize()">close</mat-icon>
    </button>
  }
</div>

<div class="ng-content" mat-dialog-content>
  <ng-content select="[dialogBody]" />
</div>

<div class="ng-content" mat-dialog-actions>
  <ng-content select="[dialogFooter]" />
</div>
